// Vendor imports
const _ = require('lodash')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Common Client V2 imports
const CardGrid = require('client-v2/common/components/card-grid')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('Feed')

class Feed extends React.PureComponent {
  constructor(props) {
    super(props)

    this.ref = React.createRef()
    this.onScroll = _.throttle(this.onScroll.bind(this), 100, { trailing: false })
    this.renderLeadingComponent = this.renderLeadingComponent.bind(this)
    this.renderTrailingComponent = this.renderTrailingComponent.bind(this)
  }

  componentDidMount() {
    this.registerScrollListener()
  }

  componentWillUnmount() {
    this.unregisterScrollListener()
  }

  registerScrollListener() {
    const el = this.ref.current
    if (typeof window === 'object' && el) {
      const { getScrollParent } = require('client/lib/window')
      this.scrollTarget = this.scrollEl = getScrollParent(el)
      if (this.scrollEl === document.body) {
        this.scrollTarget = window
      }
      this.scrollTarget.addEventListener('scroll', this.onScroll)
      this.onScroll()
    }
  }

  unregisterScrollListener() {
    if (this.scrollTarget) {
      this.scrollTarget.removeEventListener('scroll', this.onScroll)
    }
    delete this.scrollEl
    delete this.scrollTarget
  }

  onScroll() {
    if (!this.props.isMoreAvailable) {
      return
    }
    const scrollTop = this.scrollTarget.scrollY || this.scrollEl.scrollTop
    const viewportHeight = this.scrollTarget.innerHeight || this.scrollEl.clientHeight
    const contentHeight = this.scrollEl.scrollHeight
    const scrollBottom = scrollTop + viewportHeight
    const moreThreshold = contentHeight - viewportHeight
    if (scrollBottom > moreThreshold) {
      this.props.onMoreClick()
    }
  }

  renderEmptyMessage() {
    const { emptyMessage } = this.props
    if (emptyMessage) {
      return tag(emptyMessage, this.props)
    }
  }

  renderGrid() {
    if (this.props.emptyMessage) {
      return null
    }
    return (
      tag(CardGrid, Object.assign({}, this.props, {
        className: bem.element('grid'),
        renderLeading: this.renderLeadingComponent,
        renderTrailing: this.renderTrailingComponent
      }))
    )
  }

  renderLeadingComponent() {
    const { leadingComponent } = this.props
    if (leadingComponent) {
      return tag(leadingComponent, this.props)
    }
  }

  renderTrailingComponent() {
    const { trailingComponent } = this.props
    if (trailingComponent) {
      return tag(trailingComponent, this.props)
    }
  }

  render() {
    return (
      tag('div', {
        ref: this.ref,
        className: bem.block()
      },
        this.renderGrid(),
        this.renderEmptyMessage()
      )
    )
  }
}

const componentPropType = PropTypes.oneOfType([
  PropTypes.instanceOf(React.Component),
  PropTypes.func
])

Feed.propTypes = {
  // Flags
  isMoreAvailable: PropTypes.bool,
  // Values
  emptyMessage: componentPropType,
  leadingComponent: componentPropType,
  trailingComponent: componentPropType,
  // Callbacks
  onMoreClick: PropTypes.func
}

module.exports = Feed
